export class SelectTaskProgress {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    get isTaskComplete() {
        if (this.task.options.length === 0)
            return false;
        return !this.task.options.find(option => !option.isSelected && option.shouldBeSelected);
    }
    get secondsSinceSelection() {
        const selectedOption = this.task.options.find(option => option.isSelected);
        if (!selectedOption)
            return -1;
        if (!selectedOption.selectionDate)
            return -1;
        return this.task.context.app.appClock.clock_250.tickingTime - selectedOption.selectionDate.getTime();
    }
}
